/* eslint-disable react/prop-types */
import { addApolloState, initApolloClient } from "../lib/apolloClient";
import { FIND_LISTING, getPathLevelVars } from "../graphql/queries/find";
import { GET_ALL_CATEGORIES } from "../graphql/queries/categories";
import ListingsScreen from "../containers/listings-screen/ListingsScreen";
import { getPreloadedImage } from "../lib/helpers";
import config from "../common/config";

export default function Home({ initFindQueryVars, preLoads }) {
  return (
    <ListingsScreen initFindQueryVars={initFindQueryVars} preLoads={preLoads} />
  );
}

export async function getStaticProps() {
  const apolloClient = initApolloClient();

  const findQueryVars = getPathLevelVars();

  const queries = await Promise.all([
    apolloClient.query({
      query: FIND_LISTING,
      variables: findQueryVars,
    }),
    apolloClient.query({
      query: GET_ALL_CATEGORIES,
      variables: { lang: "ar" },
    }),
  ]);

  const preLoads = getPreloadedImage(
    queries[0].data.Web.find.listings,
    config.NUMBER_PRELOADED_IMAGES
  );

  return addApolloState(apolloClient, {
    props: {
      initFindQueryVars: findQueryVars,
      preLoads,
      layoutType: null,
    },
    revalidate: 1,
  });
}
